import { ReactEventHandler } from 'react';
import classNames from 'classnames';

interface IOption {
  name: string;
  value: string;
}

interface IDropdownProps {
  options: IOption[];
  placeholder: string;
  onSelect: ReactEventHandler<HTMLSelectElement>;
  defaultValue: string;
  className?: string;
}

function Dropdown({
  options,
  placeholder,
  defaultValue,
  onSelect,
  className = '',
}: IDropdownProps) {
  return (
    <select
      className={classNames('select max-w-[200px]', className)}
      defaultValue={defaultValue}
      onChange={onSelect}
    >
      <option disabled>{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.name}
        </option>
      ))}
    </select>
  );
}

export default Dropdown;
